import { render, staticRenderFns } from "./posts-list.vue?vue&type=template&id=73f63481&"
import script from "./posts-list.vue?vue&type=script&lang=js&"
export * from "./posts-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports